import { Component, Input, OnInit } from '@angular/core';
import { FileUploadDataProvider } from '@services/files/file-upload.data.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from '@services/helpers/message-service/message.service';

@Component({
	selector: 'delete-attachment-modal',
	template: require('./delete-attachment-modal.html')
})
export class DeleteAttachmentModal implements OnInit {
	@Input() file: File;
	@Input() jobId: number;
	@Input() files: File[];
	constructor(
		private fileUploadService: FileUploadDataProvider,
		private messageService: MessageService,
		public activeModal: NgbActiveModal
	) {}

	ngOnInit(): void {
		this.fileUploadService.filesList = this.files;
	}

	deleteFile(): void {
		this.fileUploadService
			.deleteFileFromServer(this.file, this.jobId)
			.subscribe(
				() => {
					this.messageService.showToaster('s_2', 'attachments');
					this.activeModal.close();
				},
				error => {
					const { errorTitle, errorMessage } = error.error;
					this.messageService.showErrorFromBackend(errorTitle, errorMessage);
					this.activeModal.dismiss();
				}
			);
	}

	onDismiss(): void {
		this.activeModal.dismiss();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/jobs/common/delete-atachment-modal/delete-attachment-modal.ts